
function formatAwardValues (campaigns) {
  let priceOptions = []
  campaigns.forEach(campaign => {
    priceOptions.push(campaign.eventData.value)
  })
  priceOptions = priceOptions.sort(function (a, b) { return a - b })
  const minValue = Math.min(...priceOptions)
  const maxValue = Math.max(...priceOptions)
  return { priceOptions, minValue, maxValue }
}

function reduceCampaigns (campaigns) {
  const reducedCampaings = []
  campaigns.forEach(campaign => {
    reducedCampaings.push({ id: campaign.id, value: campaign.eventData.value })
  })
  return reducedCampaings
}

export default { formatAwardValues, reduceCampaigns }



// WEBPACK FOOTER //
// ./src/store/utils/awards.js